/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { Slug } from './Slug'
import { SlugFromJSON, SlugFromJSONTyped, SlugToJSON } from './Slug'

/**
 *
 * @export
 * @interface EnvelopedSlugSlugList
 */
export interface EnvelopedSlugSlugList {
  /**
   *
   * @type {Slug}
   * @memberof EnvelopedSlugSlugList
   */
  body: Slug
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedSlugSlugList
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedSlugSlugList interface.
 */
export function instanceOfEnvelopedSlugSlugList(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedSlugSlugListFromJSON(json: any): EnvelopedSlugSlugList {
  return EnvelopedSlugSlugListFromJSONTyped(json, false)
}

export function EnvelopedSlugSlugListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedSlugSlugList {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: SlugFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedSlugSlugListToJSON(value?: EnvelopedSlugSlugList | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: SlugToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
